export const DROPDOWN_OPTIONS = [
  {
    labelKey:
      'digitalCampaigns.mediaPlan.budgetDistribution.dropdown.options.market',
    value: 'markets',
  },
  {
    labelKey:
      'digitalCampaigns.mediaPlan.budgetDistribution.dropdown.options.platform',
    value: 'platforms',
  },
] as const;
